import { generateUrl } from "@services/generateUrl/generateUrl"
import { onRequestSuccess, onResponseRejected } from "@services/interceptors"
import axios from "axios"

const INITIAL_QUIZ_URL = generateUrl()

const initialQuizApiInstance = axios.create({
    baseURL: `${INITIAL_QUIZ_URL}/fc-initial-quiz/api/v1`
})

initialQuizApiInstance.interceptors.request.use(onRequestSuccess, undefined)
initialQuizApiInstance.interceptors.response.use(undefined, onResponseRejected)

export default initialQuizApiInstance
